import * as React from "react"
import type { SVGProps } from "react"
const SvgAnalytics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.62 21.28q.3.3.71.3.43 0 .72-.3a1 1 0 0 0 .28-.7v-9a1 1 0 0 0-.28-.72 1 1 0 0 0-.72-.29 1 1 0 0 0-.7.29 1 1 0 0 0-.3.71v9q0 .42.3.71m11.38.3a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7v-9q0-.44.29-.72a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v9q0 .42-.29.71a1 1 0 0 1-.71.29Zm-5.33 0a1 1 0 0 1-.72-.3 1 1 0 0 1-.28-.7v-5q0-.44.28-.72a1 1 0 0 1 .72-.29q.42 0 .7.29.3.3.3.71v5q0 .43-.3.71a1 1 0 0 1-.7.3M4 21.57a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.71v-5q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v5q0 .42-.29.71a1 1 0 0 1-.71.29Zm16.8-17.6a1 1 0 0 1-.2 1.4l-5.33 4a1 1 0 0 1-1.2 0L9.33 5.81 4.6 9.37a1 1 0 1 1-1.2-1.6l5.33-4a1 1 0 0 1 1.2 0l4.74 3.55 4.73-3.55a1 1 0 0 1 1.4.2" />
  </svg>
)
export default SvgAnalytics
